import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataMessageModel } from '@core/model/dataMessage.model';
import { CommentProductModel } from '@core/model/commentProduct.model';
import { NgbRatingConfig } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-modal-qualification',
    templateUrl: './modal-qualification.component.html',
    styleUrls: ['./modal-qualification.component.scss']
})
export class ModalQualificationComponent implements OnInit {
    icon: any;
    labelTitile: string;
    textDescription: any;
    status: any;
    button = false;
    isRating = false;
    hovered: any;
    submitted = false;
    onAccept = new EventEmitter();
    onCancel = new EventEmitter();
    commentInfoModel: CommentProductModel = new CommentProductModel();
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DataMessageModel,
        private ngbRatingConfig: NgbRatingConfig) {
    }
    ngOnInit() {
        this.labelTitile = this.data.labelTitile;
        this.status = this.data.status;
        this.commentInfoModel = this.data.ratingData;
    }

    onRateChange() {
        this.submitted = false;
    }

    validateComment() {
        if (this.commentInfoModel.Comment !== '') {
            this.submitted = false;
        } else {
            this.submitted = true;
        }
    }

    accept() {
        if (this.commentInfoModel.Qualification > 0) {
            this.submitted = false;
            if (this.commentInfoModel.Comment !== '') {
                this.submitted = false;
                this.onAccept.emit(this.commentInfoModel);
            } else {
                this.submitted = true;
            }
        } else {
            this.submitted = true;
        }
    }

    cancel() {
        this.onCancel.emit(false);
    }
}
